(function () {
    window.addEventListener('DOMContentLoaded', () => {
      const banner_block = document.querySelectorAll('.js-banner');
      const header = document.querySelector('[data-section-id="header"]');
      const sectionHeader = document.querySelector('.section-header');
      const TRIGGER = document.querySelectorAll('.js-trigger');

      banner_block.forEach(function(el){
        if (localStorage.getItem(el.dataset.banner) !== 'off') {
          el.style.display = 'block';
          header.style.paddingTop = el.clientHeight / 2 + 'px';
    
          if (sectionHeader) {
            sectionHeader.classList.add('section-header--with-banner');
            sectionHeader.style.setProperty('--margin', el.clientHeight / 2 + 'px');
          }
        }
      });

      TRIGGER.forEach(function(el){
        el.addEventListener('click', function () {
          const _ = this;
          localStorage.setItem(_.dataset.banner, 'off');
          header.style.paddingTop = '0px';
          _.parentNode.style.display = "none";
    
          if (sectionHeader) {
            sectionHeader.classList.remove('section-header--with-banner');
          }
        });
      })
    });
  })();
  

  
